import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  startedFromSavedPriorities: false,
  wizardStep: 0,
  selectedState: null,
  selectedCounty: null,
  landCoverSelections: [],
  prioritySelections: [],
  notSelected: false,
};

const wizardSlice = createSlice({
  name: "wizard",
  initialState,
  reducers: {
    nextWizardStep: (state) => {
      state.wizardStep += 1;
    },
    prevWizardStep: (state) => {
      state.wizardStep -= 1;
    },
    setWizardStep: (state, action) => {
      state.wizardStep = action.payload;
    },
    setStartedFromSavedPriorities: (state, action) => {
      state.startedFromSavedPriorities = action.payload;
    },
    openWizard: (state) => {
      state.open = true;
    },
    closeWizard: (state) => {
      state.open = false;
    },
  },
});

export const {
  nextWizardStep,
  prevWizardStep,
  setWizardStep,
  openWizard,
  closeWizard,
  setStartedFromSavedPriorities,
} = wizardSlice.actions;

export default wizardSlice.reducer;
